<div class="title">
    <div>Intensity mapping</div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<form class="job-selection-dialog-content" (keyup.enter)="startJob()">
    <cds-form-group layout="vertical">
        <cds-select>
            <label>Target layer</label>
            <select
                name="target-layer-selection"
                [ngModel]="selectedTargetLayer"
                (ngModelChange)="selectTargetLayer($event)"
            >
                <ng-container *ngFor="let layer of segmentationLayers$ | async">
                    <option [ngValue]="layer">{{ layer.name }}</option>
                </ng-container>
            </select>
        </cds-select>
        <cds-select>
            <label>Mask Layer (Optional)</label>
            <select
                name="mask-layer-selection"
                [ngModel]="selectedMaskLayer"
                (ngModelChange)="selectMaskLayer($event)"
            >
                <ng-container *ngFor="let layer of segmentationLayers$ | async">
                    <option [ngValue]="layer">{{ layer.name }}</option>
                </ng-container>
            </select>
        </cds-select>
        <div *ngIf="siblingDatasets!.length > 1">
            <cds-checkbox>
                <label>Run the job on datasets in the same folder</label>
                <input
                    id="runBatchJob"
                    type="checkbox"
                    name="runBatchJob"
                    [(ngModel)]="runBatchJob"
                />
            </cds-checkbox>
            <ul class="batch-datasets" [class.show]="runBatchJob">
                <li *ngFor="let dataset of siblingDatasets">
                    {{ dataset }}
                </li>
            </ul>
        </div>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="startJob()" [disabled]="!canStart">Start Job</cds-button>
</div>
